import * as React from 'react';
export const TJSvg = React.forwardRef(function TJSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.994 2A1.992 1.992 0 0 0 0 4v2h16V4c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1-1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM7.5 7a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1.5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-2.5 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z',
      }),
    ),
  );
});
TJSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TJ = {
  category: 'flag',
  colorable: false,
  name: 'TJ',
  svg: TJSvg,
};
